module.exports = __webpack_public_path__ + "static/media/sample-logo.6861168e.svg";